export default "__VITE_ASSET__CnJEgRMY__"